import { Select } from '@kaizen/select';
import React, { useState } from 'react';
import { SelectOption, CheckedOption } from '../../types';

interface Props {
  options: SelectOption[];
  currentSelection: string | null;
  inputId: string;
  ariaLabelledBy: string;
  questionId: string;
  validationError?: string;
  containerRef: React.RefObject<HTMLDivElement>;
  onSave: (
    checkedOptions: CheckedOption[],
    otherValue: string,
    checkedOption: string,
    answered: boolean
  ) => void;
}

const SingleSelectDropdown = ({
  options,
  currentSelection,
  inputId,
  ariaLabelledBy,
  questionId,
  validationError,
  containerRef,
  onSave,
}: Props) => {
  const [selectedOption, setSelectedOption] = useState(currentSelection);

  const handleChange = (value: any) => {
    setSelectedOption(value);
    onSave(
      [
        {
          id: value,
          checked: true,
        },
      ],
      '',
      value,
      true
    );
    additionalUpdates(value);
  };

  const additionalUpdates = (value: any) => {
    // Update the record of the selected options still living in Haml, for dependent question functionality
    $(`input[data-select-option][data-question-id="${questionId}"]`).val(
      'false'
    );

    $(`input[data-select-option="${value}"]`).val('true');

    // Send back to jQuery for some adjustments to the .question container that we can't make here yet
    $(document).trigger('reactAnswerChange', {
      container: containerRef.current,
      answered: true,
    });
  };

  return (
    <Select
      id={inputId}
      trigger={(triggerProps, ref) => (
        <Select.TriggerButton
          {...triggerProps}
          ref={ref}
          id={inputId}
          aria-describedby={validationError}
        />
      )}
      data-automation-id={inputId}
      aria-labelledby={ariaLabelledBy}
      items={options}
      selectedKey={selectedOption}
      onSelectionChange={handleChange}
      data-focus-to-on-navigate={true}
      isFullWidth
    />
  );
};

export default SingleSelectDropdown;
